import { useQuery } from "@tanstack/react-query";
import { QUERY_CONSTANTS } from "../queryKeys";
import { ICountry } from "../../models/Country";
import { CountriesService } from "../../services/countries.service";

export const useGetAllCountries = () => {
  return useQuery<ICountry[], Error>({
    queryKey: [QUERY_CONSTANTS.GET_ALL_COUNTRIES],
    queryFn: () => CountriesService.getAllCountries().then((res) => res.data),
  });
};
